import {AppConfigType} from "../reducers/appConfigReducer";

export const getAppConfig = (store: any): AppConfigType => {
    return store.appConfig;
};

export const getStoreManagerURL = (store: any): string => {
	return store.appConfig.storeManagerUrl;
};
